// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type FileOperationQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type FileOperationQuery = { __typename?: 'Query', fileOperation: { __typename?: 'FileOperation', id: string, kind: Types.FileOperationKind, status: Types.FileOperationStatus, resultFileId?: string | null, attachmentId?: string | null, message?: string | null, errorCode?: string | null, errorMessage?: string | null, createdAt: any, finishedAt?: any | null } };


export const FileOperationDocument = gql`
    query FileOperation($id: ID!) {
  fileOperation(id: $id) {
    id
    kind
    status
    resultFileId
    attachmentId
    message
    errorCode
    errorMessage
    createdAt
    finishedAt
  }
}
    `;

/**
 * __useFileOperationQuery__
 *
 * To run a query within a React component, call `useFileOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFileOperationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FileOperationQuery, FileOperationQueryVariables> & ({ variables: FileOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FileOperationQuery, FileOperationQueryVariables>(FileOperationDocument, options);
      }
export function useFileOperationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FileOperationQuery, FileOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FileOperationQuery, FileOperationQueryVariables>(FileOperationDocument, options);
        }
// @ts-ignore
export function useFileOperationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FileOperationQuery, FileOperationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileOperationQuery, FileOperationQueryVariables>;
export function useFileOperationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileOperationQuery, FileOperationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FileOperationQuery | undefined, FileOperationQueryVariables>;
export function useFileOperationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FileOperationQuery, FileOperationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FileOperationQuery, FileOperationQueryVariables>(FileOperationDocument, options);
        }
export type FileOperationQueryHookResult = ReturnType<typeof useFileOperationQuery>;
export type FileOperationLazyQueryHookResult = ReturnType<typeof useFileOperationLazyQuery>;
export type FileOperationSuspenseQueryHookResult = ReturnType<typeof useFileOperationSuspenseQuery>;
export type FileOperationQueryResult = ApolloReactCommon.QueryResult<FileOperationQuery, FileOperationQueryVariables>;